import { useState } from "react";
import { Box, ClickAwayListener, IconButton, Tooltip, Typography } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { milkProblemExplanation } from "../../utils/milk-calculation-messages.js";

const MilkCalculationProblem = ({ problem }) => {
    const [hovered, setHovered] = useState(false);
    const [pinned, setPinned] = useState(false);
    const close = () => { setHovered(false); setPinned(false); };
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
            <Typography variant="body2" color="error">{problem.title}</Typography>
            <ClickAwayListener onClickAway={close}>
                <span>
                    <Tooltip title={milkProblemExplanation(problem)} arrow describeChild open={hovered || pinned}
                        slotProps={{ tooltip: { sx: { fontSize: "0.95rem", lineHeight: 1.5, maxWidth: 380 } } }}
                        onOpen={() => setHovered(true)} onClose={() => setHovered(false)} disableTouchListener>
                        <IconButton size="small" color="error" aria-label={`Επεξήγηση: ${problem.title}`}
                            aria-expanded={hovered || pinned} onClick={() => setPinned((value) => !value)}
                            onBlur={close} onKeyDown={(event) => { if (event.key === "Escape") close(); }}
                            sx={{ minWidth: 40, minHeight: 40 }}>
                            <InfoOutlined fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </span>
            </ClickAwayListener>
        </Box>
    );
};

export default MilkCalculationProblem;
